module.exports = __webpack_public_path__ + "img/T947.75dc26fa.jpg";